// import { REHYDRATE } from 'redux-persist/constants'
import _omit from "lodash/omit";

const initialState = {
	loading: false,
	items: [],
	codes: [],
	shoppertrack: null,
	couponInProcess: false,
	couponSuccess: "",
	couponError: {},
	couponDeleteError: {},
    donationLoading: false,
    donationSuccess: "",
    donationError: {},
    donationDeleteError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		// case 'persist/REHYDRATE':
		// 	console.log(state, action)
		// 	return state

		// ===================================
		//  SET CART DATA
		// ===================================
		case "SET_CART":
			// console.log("SET_CART", action.payload);
			if(action.payload.cart_summary.item_count === 0){
				return {
					...action.payload
				}
			} else {
				return {
					...state,
					...action.payload
				};
			}
		
		// ===================================
		//  GET CART DATA LOADING FLAGS
		// ===================================
		case "GET_CART_LOADING":
			return{
				...state,
				loading: true
			};
		case "GET_CART_DONE":
			return{
				...state,
				loading: false
			};
		// ===================================
		//	ADD PRODUCT
		// ===================================
		case "ADD_CART_IN_PROCESS":
			return {
				...state,
				inProccess: true
			};

		case "ADD_CART_SUCCESS":
			let returningState = {
				...action.payload.cart,
				cart_summary: action.payload.cart_summary,
				shoppertrack: action.payload.customer,
				inProccess: false,
				success: action.payload.message
			};

			// console.log('New State:', returningState)

			return returningState;

		case "ADD_CART_ERROR":
			return {
				...state,
				inProccess: false,
				error: action.error
			};

		// ===================================
		//	UPDATE QTY
		// ===================================
		case "UPDATE_CART_QTY_IN_PROCESS":
			return {
				..._omit(state, ["updateError", "updateSuccess"]),
				updateInProcess: true,
				updatedId: action.item_id
			};

		case "UPDATE_CART_QTY_SUCCESS":
			// console.log(action)

			let updatedState = {
				...state,
				...action.payload.cart,
				cart_summary: action.payload.cart_summary,
				updateInProcess: false,
				updateSuccess: action.payload.message,
				updatedId: action.item_id
			};

			// If no items in case, reset the items property to empty array
			if (!action.payload.cart.items) {
				updatedState = {
					...updatedState,
					items: []
				};
			}

			return updatedState;

		case "UPDATE_CART_QTY_ERROR":
			return {
				...state,
				updateInProcess: false,
				updateError: action.error,
				updatedId: action.item_id
			};

		case "CLEAR_UPDATE_MESSAGES":
			return _omit(state, ["updateInProcess", "updateError", "updatedId", "updateSuccess"]);

		// ===================================
		//	DELETE PRODUCT
		// ===================================
		case "REMOVE_FROM_CART_IN_PROCESS":
			return {
				...state,
				deleteInProcess: true,
				deletedId: action.item_id
			};

		case "REMOVE_FROM_CART_SUCCESS":
			let deletedState = {
				...state,
				...action.payload.cart,
				cart_summary: action.payload.cart_summary,
				deleteInProcess: false,
				deleteSuccess: action.payload.message,
				deletedId: action.item_id
			};

			// If no items in case, reset the items property to empty array
			if (!action.payload.cart.items) {
				deletedState = {
					...deletedState,
					items: []
				};
			}

			return deletedState;

		case "REMOVE_FROM_CART_ERROR":
			return {
				...state,
				deleteInProcess: false,
				deleteError: action.error,
				deletedId: action.item_id
			};

		// ===================================
		//	ADD COUPON
		// ===================================
		case "ADD_COUPON_CART_IN_PROCESS":
			return {
				...state,
				couponInProcess: true,
				couponError: {},
				couponSuccess: ""
			};

		case "ADD_COUPON_CART_SUCCESS":
			return {
				...action.payload.cart,
				cart_summary: action.payload.cart_summary,
				shoppertrack: action.payload.customer
					? action.payload.customer
					: state.shoppertrack,
				couponInProcess: false,
				couponSuccess: action.payload.message
			};

		case "ADD_COUPON_CART_ERROR":
			// console.log(action)
			return {
				...state,
				couponInProcess: false,
				couponError: action.error
			};

		// ===================================
		//	DELETE COUPON
		// ===================================
		case "REMOVE_COUPON_FROM_CART_IN_PROCESS":
			return {
				...state,
				deleteInProcess: true,
				deletedId: action.item_id,
				couponDeleteError: ""
			};

		case "REMOVE_COUPON_FROM_CART_SUCCESS":
			// console.log(action)
			// return state

			let deletedCouponState = {
				...state,
				...action.payload.cart,
				cart_summary: action.payload.cart_summary,
				deleteInProcess: false,
				deleteSuccess: action.payload.message,
				deletedId: action.item_id
			};

			// If no items in case, reset the items property to empty array
			if (!action.payload.cart.items) {
				deletedCouponState = {
					...deletedCouponState,
					items: []
				};
			}

			return deletedCouponState;

		case "REMOVE_COUPON_FROM_CART_ERROR":
			return {
				...state,
				deleteInProcess: false,
				couponDeleteError: action.error,
				deletedId: action.item_id
			};
		// ===================================
        //	ADD DONATION
        // ===================================
        case "ADD_DONATION_CART_LOADING":
            return {
                ...state,
                donationLoading: true,
                donationError: {},
                donationSuccess: ""
            };

        case "ADD_DONATION_CART_SUCCESS":
            return {
                ...action.payload.cart,
				cart_summary: action.payload.cart_summary,
				shoppertrack: action.payload.customer
				? action.payload.customer
				: state.shoppertrack,
                donationSuccess: action.payload.message
            };

        case "ADD_DONATION_CART_ERROR":
            return {
                ...state,
                donationLoading: false,
                donationError: action.error
			};
		// ===================================
		//	DELETE DONATION
		// ===================================
		case "REMOVE_DONATION_FROM_CART_LOADING":
			return {
				...state,
				deleteInProcess: true,
				deletedId: action.item_id,
				donationDeleteError: ""
			};

		case "REMOVE_DONATION_FROM_CART_SUCCESS":
			// console.log(action)
			// return state

			let deletedDonationState = {
				...state,
				...action.payload.cart,
				cart_summary: action.payload.cart_summary,
				deleteInProcess: false,
				deleteSuccess: action.payload.message,
				deletedId: action.item_id
			};

			// If no items in case, reset the items property to empty array
			if (!action.payload.cart.items) {
				deletedDonationState = {
					...deletedDonationState,
					items: []
				};
			}

			return deletedDonationState;

		case "REMOVE_DONATION_FROM_CART_ERROR":
			return {
				...state,
				deleteInProcess: false,
				donationDeleteError: action.error,
				deletedId: action.item_id
			};
		// ===================================
		//	CLEAR
		// ===================================
		case "CLEAR_SUCCESS":
			return _omit(state, [
				"success",
				"updateInProcess",
				"updateError",
				"updatedId",
				"updateSuccess",
				"deleteInProcess",
				"deleteError",
				"deletedId",
				"deleteSuccess"
			]);

		case "CLEAR_DELETE_MESSAGES":
			return _omit(state, [
				"deleteInProcess",
				"deleteError",
				"deletedId",
				"deleteSuccess",
				"couponDeleteError",
				"donationDeleteError",
				"couponSuccess",
				"donationSuccess"
			]);

		case "CLEAR_CART":
			return initialState;

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/cart.js